export default "__VITE_ASSET__D$IDaHOV__"